(function () {
  /* 支付图标：一张透明底品牌条（PayPal / Mastercard / Visa / Amex），554×70 原图，2x 显示 */
  var PAY_STRIP = 'https://cdn.shopify.com/s/files/1/0844/9658/0805/files/veltra-payment-icons.png';
  var PAY_ALT = 'Visa, Mastercard, PayPal, American Express';

  var SOCIAL = [
    { name: 'Instagram', href: '#', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3.2" y="3.2" width="17.6" height="17.6" rx="5"/><circle cx="12" cy="12" r="4.1"/><circle cx="17.2" cy="6.9" r="1" fill="currentColor" stroke="none"/></svg>' },
    { name: 'TikTok', href: '#', svg: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M15.6 3h-2.2v11.3a2.3 2.3 0 1 1-1.9-2.3V9.7a4.6 4.6 0 1 0 4.1 4.6V8.6a5.2 5.2 0 0 0 3.2 1v-2.2a3 3 0 0 1-3.2-3.1V3z"/></svg>' },
    { name: 'Pinterest', href: '#', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="8.6"/><path d="M10.4 17.6c.5-1.9 1-4 1.3-5.4"/><path d="M9.6 12.6c-.3-1.9.9-3.6 2.9-3.6 1.7 0 2.7 1 2.7 2.6 0 1.9-1 3.3-2.4 3.3-.8 0-1.4-.6-1.2-1.4"/></svg>' },
    { name: 'Facebook', href: '#', svg: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M13.6 21v-7.2h2.5l.4-2.9h-2.9V9.1c0-.8.2-1.4 1.4-1.4h1.6V5.1c-.3 0-1.3-.1-2.4-.1-2.4 0-4 1.4-4 4v2h-2.5v2.9h2.5V21h3.4z"/></svg>' },
  ];

  var TRUST = [
    { label: 'Made in the EU', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><circle cx="12" cy="12" r="8.6"/><path d="M12 6.8v5.4l3.4 2"/></svg>' },
    { label: '30-day wear test', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M3.6 16.4c0-1.7 1.4-3 3.1-3h10.6c1.7 0 3.1 1.3 3.1 3v.9H3.6z"/><path d="M7.4 13.2V9.1c0-1.3 1.1-2.3 2.4-2.3h1.5"/><path d="M14.2 6.8h2.6"/></svg>' },
    { label: 'Free EU shipping over €80', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M2.8 7.6h9.1v7.9H2.8z"/><path d="M11.9 10.3h4.3l3.1 3.2v2H11.9z"/><circle cx="6.9" cy="17.2" r="1.6"/><circle cx="16.6" cy="17.2" r="1.6"/></svg>' },
  ];

  var LOCKUP = 'https://cdn.shopify.com/s/files/1/0844/9658/0805/files/lockup-trim.png';

  function socialRow(items) {
    return '<div class="vf-social">' + items.map(function (it) {
      return '<a class="vf-item" href="' + it.href + '" aria-label="' + it.name + '">' +
        '<span class="vf-ico">' + it.svg + '</span><span class="vf-sr">' + it.name + '</span></a>';
    }).join('') + '</div>';
  }

  function build() {
    var foot = document.querySelector('.veltra-footer');
    if (!foot) return false;

    // 1) 订阅模块下方的锁版图
    var brandCell = foot.querySelector('.vf-cell--brand');
    if (brandCell && !brandCell.querySelector('.vf-lockup')) {
      var img = document.createElement('img');
      img.className = 'vf-lockup';
      img.src = LOCKUP;
      img.alt = 'VELTRA — Shoes that hold their shape';
      img.loading = 'lazy';
      img.width = 214;
      img.height = 51;
      brandCell.appendChild(img);
    }

    if (foot.querySelector('.vf-extras')) return true;

    // 2) 信任 / 支付 / 社交
    var box = document.createElement('div');
    box.className = 'vf-extras';
    box.innerHTML =
      '<div class="vf-extras__inner">' +
        '<div class="vf-trust">' + TRUST.map(function (t) {
          return '<span class="vf-trust__item"><span class="vf-ico">' + t.svg + '</span>' + t.label + '</span>';
        }).join('') + '</div>' +
        '<div class="vf-pay"><span class="vf-pay__label">Secure payment</span>' +
          '<img class="vf-pay__strip" src="' + PAY_STRIP + '" alt="' + PAY_ALT + '" width="277" height="35" loading="lazy">' +
        '</div>' +
        socialRow(SOCIAL) +
      '</div>';

    var grid = foot.querySelector('.vf-grid');
    var bottom = foot.querySelector('.vf-bottom');
    if (grid && bottom) grid.parentNode.insertBefore(box, bottom);
    else if (grid) grid.parentNode.insertBefore(box, grid.nextSibling);
    else (foot.querySelector('.vf-wrap') || foot).appendChild(box);

    // 3) 主题自带的那行支付图标（12 个 SVG）与品牌条重复，隐藏掉
    var natives = foot.querySelectorAll('.vf-pay');
    for (var i = 0; i < natives.length; i++) {
      if (natives[i].querySelector('.vf-pay__icon')) natives[i].style.display = 'none';
    }
    return true;
  }

  if (!build()) {
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (build() || tries > 25) clearInterval(timer);
    }, 300);
  }
})();
